import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Stack } from '@optimus-web/core';
import { createFormResolver, withHookForm } from '@mews-commander/form';
import { presence, validation } from '@mews-commander/legacy-form';
import { ModalSidePanel } from '@mews-commander/ui';
import { ClientInfoFields, ClientInfoFormValues } from './ClientInfoFields';

interface ClientInfoPanelProps {
    opened: boolean;
    loading: boolean;
    onClose: () => void;
    onSubmit: (values: ClientInfoFormValues) => void;
    serviceId: string;
    defaultValues?: Partial<ClientInfoFormValues>;
}

const ClientInfoPanelComponent = withHookForm<ClientInfoFormValues, ClientInfoPanelProps>()(
    ({ opened, serviceId, loading, onClose, submit }) => (
        <ModalSidePanel
            opened={opened}
            loading={loading}
            onClose={onClose}
            title={<LocalizedText textKey={TextKey.ClientInfo} />}
            width="small"
            headerActions={null}
            actions={
                <Stack alignment="end">
                    <Button type="submit" variant="primary" onClick={submit}>
                        <LocalizedText textKey={TextKey.Save} />
                    </Button>
                </Stack>
            }
            content={<ClientInfoFields serviceId={serviceId} />}
        />
    )
);
export const ClientInfoPanel = ({ defaultValues, ...other }: ClientInfoPanelProps) => (
    <ClientInfoPanelComponent
        useFormProps={{ defaultValues, resolver: createFormResolver(validation({ bookerId: { presence } })) }}
        {...other}
    />
);
